<template>
    <v-card class="text-center d-flex flex-column stat-card">
      <v-card-text>
        <v-icon :color="color" size="36">{{ icon }}</v-icon>
        <h3 class="headline font-weight-bold mt-2">{{ value }}</h3>
        <div class="subtitle-1">{{ title }}</div>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  export default {
    name: 'VStatCard',
    props: {
      title: String,
      value: [Number, String],
      color: String,
      icon: String
    }
  }
  </script>

<style scoped>
.stat-card {
  height: 180px; /* You can adjust this value as needed */
}
</style>